import { Stack, Typography } from '@mui/material'
import BirthdaySvg from './_svgs/Birthday.svg?react'
import GraduationSvg from './_svgs/Graduation.svg?react'
import EngagementSvg from './_svgs/Engagement.svg?react'
import { useState } from 'react'
import ArrowUpNewSvg from '~/@ui/_sharedSvgs/ui/ArrowUpNew.svg?react'
import { InfoBubble } from '~/@ui/info-bubble/InfoBubble'

type Props = {
  years18: string
  years25: string
  years30: string
  interestPerAnnum: number
  className?: string
}

export const GraphSummaryChildren = ({
  years18,
  years25,
  years30,
  interestPerAnnum,
  className = '',
}: Props) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Stack className={`p-4 pr-4  bg-zBlack300 rounded-4d ${className}`}>
      <Stack className="flex-row gap-1">
        <InfoBubble text="Investičné míľniky pre vaše deti – pri dovŕšení 18, 25 alebo 30 rokov." />
        <Typography className="text-base font-bold text-zWhite200">
          Ciele investície
        </Typography>
        <ArrowUpNewSvg
          onClick={() => setIsOpen((prev) => !prev)}
          className={`ml-auto ${isOpen ? 'rotate-0' : 'rotate-180'} cursor-pointer`}
        />
      </Stack>
      {isOpen && (
        <Stack className="pb-2">
          <Stack className="gap-3 mt-4 mb-3.5">
            <Stack className="flex-row h-10 items-center">
              <BirthdaySvg />
              <Stack className="gap-1 ml-2">
                <Typography className="text-xs font-black text-zWhite200">
                  18 rokov
                </Typography>
                <Typography className="text-xs font-medium text-zGrey400">
                  Vstup do dospelosti
                </Typography>
              </Stack>
              <Typography className="text-base font-black text-zWhite200 ml-auto">
                {`${years18} €`}
              </Typography>
            </Stack>

            <Stack className="flex-row h-10 items-center">
              <GraduationSvg />
              <Stack className="gap-1 ml-2">
                <Typography className="text-xs font-black text-zWhite200">
                  25 rokov
                </Typography>
                <Typography className="text-xs font-medium text-zGrey400">
                  Promócie na vysokej škole
                </Typography>
              </Stack>
              <Typography className="text-base font-black text-zWhite200 ml-auto">
                {`${years25} €`}
              </Typography>
            </Stack>

            <Stack className="flex-row h-10 items-center">
              <EngagementSvg />
              <Stack className="gap-1 ml-2">
                <Typography className="text-xs font-black text-zWhite200">
                  30 rokov
                </Typography>
                <Typography className="text-xs font-medium text-zGrey400">
                  Štart do samostatného života
                </Typography>
              </Stack>
              <Typography className="text-base font-black text-zWhite200 ml-auto">
                {`${years30} €`}
              </Typography>
            </Stack>
          </Stack>

          <Typography className="text-xs font-medium text-zGrey400 italic">
            {`Kalkulačka počíta s výnosom v Bonashipe ${interestPerAnnum} % ročne.`}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
